import { useEffect } from 'react';

/**
 * Global lock counter so nested modals/dialogs don't unlock the body early,
 * and so cleanup always clears leftover overflow styles (e.g. from Radix RemoveScroll).
 */
let lockCount = 0;

function lockBody() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
}

function unlockBody() {
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
    document.documentElement.style.removeProperty('overflow');
    document.body.removeAttribute('data-scroll-locked');
}

/**
 * يمنع scroll الصفحة أثناء فتح الـ popup/modal، ويرجّعه بعد الإغلاق.
 */
export function useBodyScrollLock(isOpen: boolean) {
    useEffect(() => {
        if (!isOpen) return;

        if (lockCount === 0) {
            lockBody();
        }
        lockCount += 1;

        return () => {
            lockCount = Math.max(0, lockCount - 1);
            if (lockCount === 0) {
                unlockBody();
            } else {
                // Nested lock still active — re-apply in case Radix RemoveScroll cleared styles
                lockBody();
            }
        };
    }, [isOpen]);
}
